import "./App.css";
import { lazy, Suspense } from "react";

import Home from "./pages/home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";

// Services
import LawnCare from "./pages/services/LawnCare";
import LandscapeDesign from "./pages/services/landscapeDesign";
import HardscapingOutdoorConstruction from "./pages/services/HardscapingOutdoorConstruction";
import PropertyCleanup from "./pages/services/PropertyCleanup";

// Areas
import Bremerton from "./pages/Areas/Bremerton";
import PortOrchard from "./pages/Areas/Port Orchard";

// Components
import Header from "./components/Header";
import Footer from "./components/Footer";

// React Router
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

// Blog (lazy-loaded so it doesn't slow down other pages)
const Blog = lazy(() => import("./pages/Blog"));
const BlogPost = lazy(() => import("./pages/BlogPost"));
const BlogDashboard = lazy(() => import("./pages/BlogDashboard"));

function Layout() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  return (
    <>
      {!isAdmin && <Header />}

      <Suspense fallback={<div style={{ minHeight: "60vh" }} />}>
        <Routes>
          {/* Main Pages */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />

          {/* Services */}
          <Route path="/services/lawn-care" element={<LawnCare />} />
          <Route path="/services/landscape-design" element={<LandscapeDesign />} />
          <Route path="/services/hardscaping" element={<HardscapingOutdoorConstruction />} />
          <Route path="/services/property-cleanup" element={<PropertyCleanup />} />

          {/* Areas */}
          <Route path="/areas/port-orchard" element={<PortOrchard />} />
          <Route path="/areas/bremerton" element={<Bremerton />} />

          {/* Blog */}
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />

          {/* Admin */}
          <Route path="/admin" element={<BlogDashboard />} />

          {/* 404 – any URL that doesn't match a page above */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>

      {!isAdmin && <Footer />}
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
}

export default App;